import type { InteractionOperationalState } from './interaction-operational-contracts'

export type ConversationAttention = 'NEEDS_ACTION' | 'NEEDS_REVIEW' | 'NONE'

// One attention status per conversation, from the two independent canonical
// signals. An open Action Request always wins: a conversation that needs
// action is never also presented as needing review. Review applies only when
// no action is open and newer activity is not covered by a review.
export function conversationAttention(
  state: InteractionOperationalState | null | undefined
): ConversationAttention | null {
  if (!state) return null
  if (state.needsAction) return 'NEEDS_ACTION'
  if (state.reviewStatus === 'NEEDS_REVIEW') return 'NEEDS_REVIEW'
  return 'NONE'
}
